import type { SessionStepDto } from '../../schemas/sessionSchemas';

// GST Verification step — Basic (Whitebooks) / Advance (Zoop, ULIP auto-fallback).
export function isGstStep(step: SessionStepDto) {
  return /gst/i.test(step.stepType) || /gst/i.test(step.displayName);
}

// GSTIN: 2-digit state code + 10-char PAN + 1-digit entity number + 'Z' + 1
// alphanumeric checksum (matches the gateway's GSTIN regex).
export function isValidGstin(value: string): boolean {
  return /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
    value.trim().toUpperCase(),
  );
}
